import React from "react";
import {
  CareIcon,
  ChildCareIcon,
  DentalIcon,
  GPSurgeriesIcon,
  DevelopmentIcon,
  HotelsIcon,
  LeisureIcon,
  PharmaciesIcon,
  PubsIcon,
  RestaurantsIcon,
  RetailIcon,
  ShareholderProtectionIcon,
  LifeInsuranceIcon,
  IncomeProtectionIcon,
  ContractIcon,
  BrainIcon,
  PeopleIcon,
  HandshakeIcon,
  TargetIcon,
  BgLogoIcon,
} from "../assets/icons/AllIcons";
import { LogoC } from "../assets/icons/LogoC";

export const useDisplaySectorIconByCodename = (
  codename: string,
  className?: string | undefined
) => {
  switch (codename) {
    case "care":
      return <CareIcon className={className ?? undefined} />;
    case "childcare":
      return <ChildCareIcon className={className ?? undefined} />;
    case "dental_practices":
      return <DentalIcon className={className ?? undefined} />;
    case "gp_surgeries":
      return <GPSurgeriesIcon className={className ?? undefined} />;
    case "health":
      return <GPSurgeriesIcon className={className ?? undefined} />;
    case "hotels":
      return <HotelsIcon className={className ?? undefined} />;
    case "leisure":
      return <LeisureIcon className={className ?? undefined} />;
    case "pharmacies":
      return <PharmaciesIcon className={className ?? undefined} />;
    case "pubs":
      return <PubsIcon className={className ?? undefined} />;
    case "restaurants":
      return <RestaurantsIcon className={className ?? undefined} />;
    case "retail":
      return <RetailIcon className={className ?? undefined} />;
    case "other":
      return <LogoC className={className ?? undefined} />;
    case "development":
      return <DevelopmentIcon className={className ?? undefined} />;
    case "life_insurance":
      return <LifeInsuranceIcon className={className ?? undefined} />;
    case "shareholder_protection":
      return <ShareholderProtectionIcon className={className ?? undefined} />;
    case "income_protection":
      return <IncomeProtectionIcon className={className ?? undefined} />;
    case "brain":
      return <BrainIcon className={className ?? undefined} />;
    case "contract":
      return <ContractIcon className={className ?? undefined} />;
    case "handshake":
      return <HandshakeIcon className={className ?? undefined} />;
    case "people":
      return <PeopleIcon className={className ?? undefined} />;
    case "target":
      return <TargetIcon className={className ?? undefined} />;
  }
};
